var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequests(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.87772 15.6841C1.88967 16.069 1.90165 16.4551 1.90165 16.8412C4.70886 16.8412 7.51607 16.8412 10.3305 16.8388C9.59332 16.0641 9.14087 15.016 9.14087 13.8622C9.14087 11.7408 10.6705 9.97659 12.687 9.61238C12.4234 9.57082 12.1495 9.54878 11.8665 9.54749H9.84178C11.8786 8.82787 12.9886 7.30327 12.7568 5.49813C12.5251 3.72959 11.1224 2.37574 9.3905 2.25377C7.65855 2.1318 6.07296 3.24171 5.60948 4.92488C5.32895 5.94942 5.47532 6.92516 6.02417 7.81554C6.57303 8.7181 7.40241 9.24257 8.40255 9.5231C7.96222 9.54342 7.52941 9.54493 7.09785 9.54643C6.75242 9.54764 6.4078 9.54884 6.06076 9.55969C3.9995 9.62067 2.18217 11.1331 1.92604 13.1822C1.82555 14.0028 1.85155 14.8407 1.87772 15.6841Z",
    fill: "#AAABAB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8705 18.3753C16.2557 18.3753 18.1893 16.4417 18.1893 14.0566C18.1893 11.6714 16.2557 9.73779 13.8705 9.73779C11.4853 9.73779 9.55176 11.6714 9.55176 14.0566C9.55176 16.4417 11.4853 18.3753 13.8705 18.3753ZM16.6835 12.6508C16.8562 12.472 16.8512 12.1871 16.6724 12.0145C16.4936 11.8418 16.2087 11.8468 16.0361 12.0256L13.0301 15.139L11.6944 13.8479C11.5157 13.6751 11.2308 13.68 11.0581 13.8587C10.8854 14.0373 10.8902 14.3222 11.0689 14.495L12.7283 16.099C12.8141 16.182 12.9294 16.2275 13.0488 16.2254C13.1682 16.2234 13.2818 16.1739 13.3648 16.0881L16.6835 12.6508Z",
    fill: "#AAABAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequests);
export default __webpack_public_path__ + "static/media/requests.cc4308c81e2dea658523497cd0a2d0ff.svg";
export { ForwardRef as ReactComponent };